import React, {Component} from "react";
import SubscriptionProductItem from "./SubscriptionProductItem";
import SubscriptionDeliveries from "./SubscriptionDeliveries";
import {pluralizeWithPrefix} from "../../lib/TextFormatter";
import AddressInline from "../../components/AddressInline";
import WarningBanner from "../../components/WarningBanner";
import Table from "../../components/Table";
import Button from "../../components/Button";
import {longDateFormat} from "../../lib/DateFormatter";
import {currencyFormat} from "../../lib/TextFormatter";
import {cx} from "../../lib/ClassSet";
import {
  formatSubscriptionStatus,
  isSubscriptionPauseDeferred,
  isSubscriptionCancellationDeferred,
  canCancelSubscription,
  canUndoCancelSubscription,
  canUndoPauseSubscription,
  canPauseSubscription,
  canRestartSubscription,
  } from "../../lib/SubscriptionStatus";
import {
  indexSurchargeProducts,
  getSubscriptionTotals
  } from "../../lib/SubscriptionHelper";
import {
  requestChangeSubscriptionQuantity
  } from "../../actions/AccountApiActions";

class SubscriptionItem extends Component {

  render() {
    let subscription = this.props.subscription;

    let nextDeliveryDate = "Not Available";
    if (subscription.get("hasEstimatedDeliveryDate")) {
      nextDeliveryDate = longDateFormat(subscription.get("nextEstimatedDeliveryDate"));
    }

    let classes = cx({
      "Subscription": true,
      "u-cancelled": subscription.get("status") === "cancelled",
      "u-active": subscription.get("status") === "active"
    })

    let totals = getSubscriptionTotals(subscription.get("products"), indexSurchargeProducts(subscription.get("shippingAddressSurcharges")));

    return (
      <div className={classes} key={subscription.get("subscriptionId")}>
        <div className="header">
          <div className="title">{subscription.get("name")}&nbsp;<span className="status">{formatSubscriptionStatus(subscription)}</span></div>
          <div className="buttons">
            <Button label="Rename" primary={false} size="small" onClick={this.handleRename.bind(this)} />
            <Button label="Undo Cancel" primary={true} size="small" onClick={this.handleUndoCancel.bind(this)} visible={canUndoCancelSubscription(subscription)} />
            <Button label="Undo Pause" primary={true} size="small" onClick={this.handleUndoPause.bind(this)} visible={canUndoPauseSubscription(subscription)} />
            <Button label="Pause" primary={false} size="small" onClick={this.handlePause.bind(this)} visible={canPauseSubscription(subscription)} />
            <Button label="Cancel" primary={false} size="small" onClick={this.handleCancel.bind(this)} visible={canCancelSubscription(subscription)} />
            <Button label="Restart" primary={false} size="small" onClick={this.handleRestart.bind(this)} visible={canRestartSubscription(subscription)} />
            <Button label="Log" primary={false}  size="small" onClick={this.handleViewLog.bind(this)} />
          </div>
        </div>
        <WarningBanner show={isSubscriptionPauseDeferred(subscription)} error={false} message="The subscription will automatically pause when the current delivery has been processed." />
        <WarningBanner show={isSubscriptionCancellationDeferred(subscription)} error={false} message="The subscription will automatically cancel when the current delivery has been processed." />
        <div className="overview">
          <div className="left">
            <div className="part products">
              <div className="title">Subscribed products</div>
              <Table 
                data={subscription.get("products")} 
                renderer={SubscriptionProductItem} 
                onItemClick={this.handleItemClick.bind(this)}
                onContextMenuClick={this.handleContextMenuItemClick.bind(this)}
                itemKey="productSku"
                mode="list"
                /> 
              <SubscriptionTotals totals={totals} />
              <Button label="Change Subscription" primary={false} size="small" onClick={this.handleChangeProducts.bind(this)}/>
            </div>

            <div className="part id">
              <div className="title">Subscription id</div>
              <p>{subscription.get("subscriptionId")}</p>
            </div>          

            <div className="part estimate">
              <div className="title">Next Estimated Delivery</div>
              <p>{nextDeliveryDate}</p>
            </div>          
          </div>

          <div className="info">
            <div className="part recipient">
              <div className="title">Shipping address</div>
              <AddressInline address={subscription.get("shippingAddress")} inline={false} />
              <Button label="Change Address" primary={false} size="small" onClick={this.handleChangeShippingAddress.bind(this)} />
            </div>

            <div className="part frequency">
              <div className="title">Subscription frequency</div>
              <p>Every {pluralizeWithPrefix(subscription.get("frequencyWeeks"), "week", "weeks", true)} </p>
              <Button label="Change Frequency" primary={false} size="small" onClick={this.handleChangeFrequency.bind(this)} />
              <Button label="Reschedule Delivery" primary={false} onClick={this.handleRescheduleDelivery.bind(this)} size="small" active={subscription.get("status") === "active"} />
            </div>

          </div>
        </div>

        <SubscriptionDeliveries
          subscriptionId={subscription.get("subscriptionId")}
          onSelectionChange={this.handleSelectDelivery.bind(this)}
          />
      </div>
    )    
  }

  handleSelectDelivery(id) {
    this.props.onSelectDelivery(id);
  }

  handleChangeFrequency() {
    this.props.onChangeSubscriptionFrequency(this.props.subscription.get("subscriptionId"));
  }

  handleRescheduleDelivery() {
    this.props.onRescheduleDelivery(this.props.subscription.get("subscriptionId"));
  }

  handleChangeShippingAddress() {
    this.props.onChangeSubscriptionShippingAddress(this.props.subscription.get("accountId"), this.props.subscription.get("subscriptionId"));
  }

  handleChangeQuantity() {
    this.props.onChangeSubscriptionQuantity(this.props.subscription.get("subscriptionId"));
  }

  handleChangeProducts() {
    this.props.onChangeSubscriptionProducts(this.props.subscription.get("subscriptionId"));
  }

  handleViewLog() {
    this.props.onViewSubscriptionLog(this.props.subscription.get("subscriptionId"));
  }

  handleCancel() {
    this.props.onCancel(this.props.subscription.get("subscriptionId"));
  }

  handleUndoCancel() {
    this.props.onUndoCancel(this.props.subscription.get("subscriptionId"));
  }

  handlePause() {
    this.props.onPause(this.props.subscription.get("subscriptionId"));
  }

  handleUndoPause() {
    this.props.onUndoPause(this.props.subscription.get("subscriptionId"));
  }

  handleRestart() {
    this.props.onRestart(this.props.subscription.get("subscriptionId"));
  }

  handleRename() {
    this.props.onRename(this.props.subscription.get("subscriptionId"));
  }

  handleItemClick(itemData, e) {
  }  

  handleContextMenuItemClick(productSku, x, y) {
    this.props.onShowContextualMenu(
      [
        {label: "Change quantity", cmd: requestChangeSubscriptionQuantity(this.props.subscription.get("subscriptionId"), productSku)}
      ], 
      x, y);
  }

}

function SubscriptionTotals({totals}) {

  let classNames = cx({
    "SubscriptionTotals": true,
    "u-surcharge": totals.get("surcharges") > 0
  })

  return (
    <div className={classNames}>
      <div className="total"><strong>{currencyFormat(totals.get("total"), totals.get("currency"), 2, false, false)}</strong> per delivery plus taxes</div>
      <div className="surcharge">Includes a {currencyFormat(totals.get("surcharges"), totals.get("currency"), 2, false, false)} surcharge for destination</div>
    </div>
  )
}

export default SubscriptionItem;